// removed by extract-text-webpack-plugin
module.exports = {"pre-selection-approved-page":"_1FnmGOep65Wr263AkHi1yk"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/pages/PreSelection/Approved/style.scss
// module id = 2596
// module chunks = 1